import type { EditClienteInmobiliarioModel, DetailClienteInmobiliarioModel, SubtipoPersonaEnum } from '@api/api';
import { TipoDocumentoEnum, TipoPersonaEnum } from '@api/api';

export class EditClienteInmobiliario implements EditClienteInmobiliarioModel {
    Id: string = null!;
    Nombre: string = null!;
    Apellidos: string = null!;
    Documento: string = null!;
    Telefono: string | null = null;
    TelFijo: string | null = null;
    TelMovil: string | null = null;
    Email: string = null!;
    FechaNacimiento: string | null = null;
    IdTipoCliente: string | null = null;
    IdEstadoCivil: string | null = null;
    IdNacionalidad: string | null = null;
    RutaDocumento: string | null = null;
    IbanPago: string | null = null;
    NombrePago: string | null = null;
    TipoDocumentoPago: TipoDocumentoEnum | null = null;
    DocumentoPago: string | null = null;
    ApellidosPago: string | null = null;
    TipoPersona: TipoPersonaEnum = TipoPersonaEnum.Fisica;
    RazonSocial: string | null = null;
    SubtipoPersona: SubtipoPersonaEnum | null = null;
    CIF: string | null = null;

    constructor(data?: Partial<EditClienteInmobiliario>) {
        Object.assign(this, data);
    }

    public createFromDetailClienteInmobiliario(cliente: DetailClienteInmobiliarioModel): EditClienteInmobiliario {
        Object.assign(this, cliente);
        return this;
    }
}